<template>
  <div class="item">
    <img
      :src="photoUrl"
      class="photo q-mb-md"
    >
    <div :style="labelStyle">
      {{ label }}
    </div>
    <div :style="sublabelStyle">
      {{ sublabel }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'TeamItem',
  props: {
    photoUrl: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    sublabel: {
      type: String,
      required: true,
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    sublabelStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.item {
  text-align: center;

  .photo {
    width: 100%;
    max-width: 160px;
  }
}
</style>
